"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrillSelectList = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var partition_1 = tslib_1.__importDefault(require("lodash/partition"));
var react_intl_1 = require("react-intl");
var types_1 = require("../../../types");
var DrillSelectListItem_1 = require("./DrillSelectListItem");
exports.DrillSelectList = function (props) {
    var items = props.items;
    var _a = tslib_1.__read(partition_1.default(items, function (item) {
        return types_1.isDrillDownDefinition(item.drillDefinition);
    }), 2), drillDownItems = _a[0], drillItems = _a[1];
    var renderItems = function (items) {
        return items.map(function (item) { return (react_1.default.createElement(DrillSelectListItem_1.DrillSelectListItem, { key: item.id, item: item, onClick: props.onSelect })); });
    };
    var renderDrillDownItems = function (items) {
        if ((items === null || items === void 0 ? void 0 : items.length) > 0) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "gd-drill-modal-picker-title" },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "drill_modal_picker.drill-down", tagName: "span" })),
                renderItems(items)));
        }
    };
    var renderDrillItems = function (items) {
        if ((items === null || items === void 0 ? void 0 : items.length) > 0) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "gd-drill-modal-picker-title" },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "drill_modal_picker.drill-into", tagName: "span" })),
                renderItems(items)));
        }
    };
    return (react_1.default.createElement("div", { className: "gd-drill-modal-picker-selector-list" },
        renderDrillDownItems(drillDownItems),
        renderDrillItems(drillItems)));
};
//# sourceMappingURL=DrillSelectList.js.map